import React from 'react';
import DataDrivenGuidePage from '../../components/guides/DataDrivenGuidePage';

const DataConverterGuidePage = () => <DataDrivenGuidePage slug="guide-data-converter" />;

export default DataConverterGuidePage;
